import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useMemo, useState } from "react";

function Home(props) {
  const [userLogonInfo, setUserLogonInfo] = useState("");
  const [now, setNow] = useState(new Date());
  const [userInfo] = useState(JSON.parse(localStorage.getItem("userInfo")));

  useEffect(() => {
    if (userInfo) {
      setUserLogonInfo(userInfo.UserName);
    } else {
      setUserLogonInfo("Guest");
    }
  }, [userInfo]);

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    props.setOnSchedule(false);
  }, []);

  const greeting = useMemo(() => {
    const hour = now.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  }, [now]);

  const dateLabel = useMemo(
    () =>
      now.toLocaleDateString(undefined, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    [now]
  );

  const timeLabel = useMemo(
    () =>
      now.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      }),
    [now]
  );

  const useStyles = makeStyles((theme) => ({
    page: {
      minHeight: "calc(100vh - 64px)",
      width: "100%",
      padding: theme.spacing(6, 4),
      boxSizing: "border-box",
      display: "flex",
      justifyContent: "center",
      background:
        "radial-gradient(circle at 20% 20%, #f5f6f8 0%, #e9ebef 60%, #e2e4e9 100%)",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, sans-serif",
    },
    card: {
      width: "100%",
      maxWidth: 720,
      borderRadius: 28,
      padding: theme.spacing(6, 5),
      boxShadow:
        "0 1px 2px rgba(0,0,0,0.04), 0 20px 40px rgba(0,0,0,0.08)",
      background: "rgba(255,255,255,0.75)",
      backdropFilter: "blur(20px)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    greeting: {
      fontSize: 34,
      fontWeight: 600,
      letterSpacing: "-0.02em",
      color: "#1d1d1f",
      margin: 0,
    },
    name: {
      fontSize: 34,
      fontWeight: 300,
      letterSpacing: "-0.02em",
      color: "#1d1d1f",
      margin: 0,
    },
    subtitle: {
      marginTop: theme.spacing(1.5),
      fontSize: 17,
      fontWeight: 400,
      color: "#6e6e73",
    },
    divider: {
      width: 40,
      height: 1,
      background: "#d2d2d7",
      margin: theme.spacing(4, 0),
    },
    time: {
      fontSize: 15,
      fontWeight: 500,
      color: "#86868b",
      letterSpacing: "0.02em",
      textTransform: "uppercase",
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.page}>
      <Paper elevation={0} className={classes.card}>
        <h1 className={classes.greeting}>
          {greeting}, <span className={classes.name}>{userLogonInfo}</span>
        </h1>
        <div className={classes.subtitle}>{dateLabel}</div>
        <div className={classes.divider} />
        <div className={classes.time}>{timeLabel}</div>
      </Paper>
    </div>
  );
}

export default Home;
